import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

export type BaselineCorrectionImpact = {
  affectedQUs: Array<{ id: string; name: string; color: string; totalHectares: number }>
  affectedPaddocks: string[]
}

type BaselineCorrectionConfirmModalProps = {
  open: boolean
  impact: BaselineCorrectionImpact
  isAdmin: boolean
  onConfirm: () => void
  onCancel: () => void
}

const BaselineCorrectionConfirmModal = ({
  open,
  impact,
  isAdmin,
  onConfirm,
  onCancel,
}: BaselineCorrectionConfirmModalProps) => (
  <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel}>
    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <WarningAmberIcon color="warning" />
      Confirmación de corrección de línea de base requerida
    </DialogTitle>

    <DialogContent>
      <Stack spacing={2}>
        <Typography variant="body2">
          Esta operación corrige la línea de base de lotes que pertenecen a Unidades de
          Cuantificación con áreas de muestreo. Los lotes corregidos saldrán de su Unidad de
          Cuantificación y se asignarán a una nueva, y se volverán a generar las áreas de muestreo
          de las unidades afectadas.
        </Typography>

        <Box>
          <Typography gutterBottom variant="subtitle2">
            Unidades de Cuantificación afectadas
          </Typography>
          <Stack direction="row" flexWrap="wrap" gap={1}>
            {impact.affectedQUs.map(qu => (
              <Chip
                key={qu.id}
                data-testid="qu-chip"
                label={`${qu.name} · ${qu.totalHectares.toFixed(2)} ha`}
                size="small"
                sx={{ backgroundColor: qu.color, color: '#fff', fontWeight: 600 }}
              />
            ))}
          </Stack>
        </Box>

        <Typography variant="body2">
          Lotes afectados: <strong>{impact.affectedPaddocks.length} lotes</strong>
        </Typography>

        {!isAdmin && (
          <Typography color="text.secondary" variant="body2">
            Este cambio requiere confirmación de un administrador. Solicita aprobación a un usuario
            admin.
          </Typography>
        )}
      </Stack>
    </DialogContent>

    <DialogActions>
      <Button color="inherit" onClick={onCancel}>
        Cancelar
      </Button>
      {isAdmin && (
        <Button color="warning" variant="contained" onClick={onConfirm}>
          Confirmar corrección
        </Button>
      )}
    </DialogActions>
  </Dialog>
)

export default BaselineCorrectionConfirmModal
